import RidersPreventiveCheckupStep from "components/steps/RidersPreventiveCheckupStep";

const Step14Page = () => <RidersPreventiveCheckupStep />;

export default Step14Page;
